import {
  GET_PROJECT_DATA,
  GET_PROJECT_DATA_ERROR,
  GET_PROJECT_DATA_SUCCESS,
  UPDATE_PROJECT_SESSION_DATA,
  UPDATE_PROJECT_SESSION_DATA_ERROR,
  UPDATE_PROJECT_SESSION_DATA_SUCCESS
} from './constants';

export const getProjectData = (projectId, dataTypes) => ({
  type: GET_PROJECT_DATA,
  projectId,
  dataTypes
});

export const getProjectDataSuccess = (projectId) => ({
  type: GET_PROJECT_DATA_SUCCESS,
  projectId
});

export const getProjectDataError = (projectId, error) => ({
  type: GET_PROJECT_DATA_ERROR,
  projectId,
  error
});

export const updateProjectSessionData = (projectId, values, actions) => ({
  type: UPDATE_PROJECT_SESSION_DATA,
  projectId,
  values,
  actions
});

export const updateProjectSessionDataSuccess = (projectId) => ({
  type: UPDATE_PROJECT_SESSION_DATA_SUCCESS,
  projectId
});

export const updateProjectSessionDataError = (projectId, error) => ({
  type: UPDATE_PROJECT_SESSION_DATA_ERROR,
  projectId,
  error
});
